




import { Component, Vue } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
@Component({
  components: {
    AdminIframe,
  },
})
export default class DisplayCategoryExcelBatchRegisterIframe extends Vue {
  private get remoteSrc() {    const queryObject = { ...this.$route.query, serviceType: 'PREMIUM' };
    const queryString = new URLSearchParams(queryObject).toString();
    return process.env.VUE_APP_ADMIN_REMOTE_URL + '/popup/display-category-excel-batch-register' + '?' + queryString;
  }

  private receiveMessage(e: MessageEvent) {
    if (e.data === 'SUCCESS') {
      window.opener.postMessage('SUCCESS');
    }
  }

  mounted() {
    window.addEventListener('message', this.receiveMessage);
  }

  beforeDestroy() {
    window.removeEventListener('message', this.receiveMessage);
  }
}
